import Compressor from 'compressorjs';

export const handleFileChange = (event, setFiles) => {
  const selectedFiles = Array.from(event.target.files);

  if (selectedFiles.length > 150) {
    alert("Solo podés subir hasta 150 fotos.");
    event.target.value = '';
    return;
  }

  const validFiles = selectedFiles.filter((file) => {
    if (!file.type.startsWith("image/")) {
      alert(`El archivo ${file.name} no es una imagen válida.`);
      return false;
    }
    return true;
  });

  if (validFiles.length > 0) {
    const compressedFiles = validFiles.map((file) => {
      return new Promise((resolve) => {
        new Compressor(file, {
          quality: 0.7,
          maxWidth: 2400,
          maxHeight: 2400,
          success(result) {
            if (result.size > 5 * 1024 * 1024) {
              alert(`La foto ${file.name} supera los 5 MB después de la compresión.`);
              resolve(null);
            } else {
              resolve(result);
            }
          },
          error(err) {
            console.error("Compression error:", err);
            resolve(null);
          }
        });
      });
    });

    Promise.all(compressedFiles).then((files) => {
      const finalFiles = files.filter(file => file !== null);
      setFiles(finalFiles);
    });
  }
};